import React, { Component } from 'react';
import { connect } from 'react-redux';

import { trackError } from 'helpers/ErrorUtils';
import { canReceiveNotifications, fetchNotificationSubscriptions, register, subscribe, toggleNotificationsOverlay, unSubscribe } from 'actions/notifications';
import styles from 'styles/components/notifications.scss';

export class Notification extends Component {
  constructor(props) {
    super(props);
    this.onSubscribe = this.onSubscribe.bind(this);
    this.formatSubscription = this.formatSubscription.bind(this);
    this.makeButton = this.makeButton.bind(this);
    this.onUnsubscribe = this.onUnsubscribe.bind(this);
    this.pushPrompt = this.pushPrompt.bind(this);
  }

  componentDidMount() {
    const { canReceiveNotifications } = this.props;
    // Check that service workers are supported, if so, progressively
    // enhance and add push messaging support, otherwise continue without it.
    if ('serviceWorker' in window.navigator) {
      window.navigator.serviceWorker.register('/sw.js')
        .then(() => {
          // Are Notifications supported in the service worker?
          if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
            return;
          }

          // Check if push messaging is supported
          if (!('PushManager' in window)) {
            return;
          }

          // Update state specifying they can accept push notifications
          canReceiveNotifications();
          this.onSubscribe();
        });
    }
  }

  onSubscribe(buttonPress) {
    const { subscriptionName, subscribe, fetchNotificationSubscriptions, notifications: { endpoint }, toggleNotificationsOverlay } = this.props;
    if (subscriptionName) {

      // Check the current Notification permission.
      // If its denied, it's a permanent block until the
      // user changes the permission
      if (buttonPress && window.Notification.permission === 'denied') {
        toggleNotificationsOverlay();
        return;
      }

      // Service worker already subscribed?
      if (endpoint) {
        subscribe(subscriptionName, endpoint);
      } else {
        window.navigator.serviceWorker.ready.then(serviceWorkerRegistration => {
          serviceWorkerRegistration.pushManager.getSubscription()
            .then(subscription => {
              if (!subscription && buttonPress) {
                this.pushPrompt(subscriptionName);
              } else if (subscription) {
                if (!buttonPress) {
                  fetchNotificationSubscriptions(subscription.endpoint);
                } else {
                  subscribe(subscriptionName, subscription.endpoint);
                }
                window.pushSubscription = subscription;
              }
            })
            .catch(err => {
              trackError('[Notifications getSubscription Error]', err);
            });
        });
      }
    }
  }

  onUnsubscribe() {
    const { unSubscribe, subscriptionName, notifications: { endpoint } } = this.props;
    if (subscriptionName && endpoint) {
      unSubscribe(subscriptionName, endpoint);
    }
  }

  formatSubscription(subscription) {
    const { subscriptionName } = this.props;
    const jsonSubscription = JSON.parse(JSON.stringify(subscription));

    jsonSubscription['name'] = subscriptionName;

    // Determine which browser they're using (ie. CHROME || FIREFOX)
    if (/android/.test(jsonSubscription.endpoint)) {
      jsonSubscription['devicePlatform'] = 'CHROME';
    } else if (/mozilla/.test(jsonSubscription.endpoint)) {
      jsonSubscription['devicePlatform'] = 'FIREFOX';
    } else {
      jsonSubscription['devicePlatform'] = null;
    }
    return jsonSubscription;
  }

  makeButton() {
    const { value, notifications: { allowed, subscriptions }, subscriptionName } = this.props;
    if (allowed) {
      if (subscriptions[subscriptionName] && subscriptions[subscriptionName].subscribed) {
        return <button type="button" onClick={this.onUnsubscribe}>Unsubscribe</button>;
      }
      return <button type="button" onClick={this.onSubscribe}>{value}</button>;
    }
  }

  pushPrompt() {
    const { register, toggleNotificationsOverlay } = this.props;
    window.navigator.serviceWorker.ready.then(serviceWorkerRegistration => {
      serviceWorkerRegistration.pushManager.subscribe({ userVisibleOnly:true })
        .then(subscription => {
          register(this.formatSubscription(subscription));
        })
        .catch(e => {
          if (window.Notification.permission === 'denied' || window.Notification.permission === 'default') {
            // The user denied the notification permission;
            toggleNotificationsOverlay();
          } else {
            // A problem occurred with the subscription;
            trackError('[Notifications registration Error]', e);
          }
        });
    });
  }

  render() {
    return (
      <span className={styles.notificationWrapper}>
        {this.makeButton()}
      </span>
    );
  }
}

function mapStateToProps(state) {
  return {
    notifications: state.notifications
  };
}

export default connect(mapStateToProps, {
  register,
  toggleNotificationsOverlay,
  subscribe,
  unSubscribe,
  fetchNotificationSubscriptions,
  canReceiveNotifications
})(Notification);
